import styled from 'styled-components';
import { Col } from 'react-bootstrap';
import { WindowBreakpoints } from 'modules/core/enums/windowBreakpoints.enum';

export const SummaryButtonGroup = styled.div`
  display: flex;
  width: 400px;
  justify-content: space-between;

  @media (max-width: ${WindowBreakpoints.small}px) {
    width: auto;

    & > :nth-child(1),
    & > :nth-child(2) {
      display: none;
    }
  }
`;

export const ApprovedLoanCol = styled(Col)`
  margin-bottom: 10px;

  @media (max-width: ${WindowBreakpoints.xxxLarge + 1}px) {
    &:nth-child(1) {
      flex: 0 0 100%;
      max-width: 100%;
    }

    &:nth-child(2) {
      flex: 0 0 50%;
      max-width: 50%;
    }

    &:nth-child(3) {
      flex: 0 0 50%;
      max-width: 50%;
    }
  }

  @media (max-width: ${WindowBreakpoints.small}px) {
    &:nth-child(2) {
      flex: 0 0 100%;
      max-width: 100%;
    }

    &:nth-child(3) {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
